import _ from 'lodash';
import React from 'react';

import {
  TeamInformation,
  LocationsSection
} from 'containers/MyTeams/components/shared';
import {PermissionsNamespace} from './components';

import './styles.css';

const TeamPermissionsForm = ({
  team,
  locationSpecific,
  generic,
  selectedPermissions,
  changePermissionField
}) => (
  <form className="TeamPermissionsForm">
    <TeamInformation team={team} />
    {!_.isEmpty(team.locations) && (
      <LocationsSection locations={team.locations} />
    )}
    <PermissionsNamespace
      header="Location Specific Permissions"
      permissions={locationSpecific}
      selectedPermissions={selectedPermissions}
      changePermissionField={changePermissionField}
    />
    <PermissionsNamespace
      header="Generic Permissions"
      permissions={generic}
      selectedPermissions={selectedPermissions}
      changePermissionField={changePermissionField}
    />
  </form>
);

export default TeamPermissionsForm;
